module.exports = __webpack_public_path__ + "img/instagram-blue.bdd9de09.svg";